// The board's shared lighting-rig constants, in a dependency-free module so
// the scene (tableScene), the card materials (cardMesh) and the glare guard
// (cardMesh.finish.test.js) all read ONE definition. qa#78 regressed twice on
// hand-copied values drifting apart (the cards' env veil vs the table's, the
// test's light rig vs the shipped one) - anything here is load-bearing for
// that guard, so change it here, never restate it.

// The day key light. Its elevation (~56 degrees) is the band qa#78's retest
// validated as uniform: at the DEFAULT match camera its specular mirror point
// sits at the table edge rather than mid-board. The night moon is pinned to
// the SAME elevation (tableScene.applyMoonPosition derives from this). The
// pin is defense in depth - the camera zooms/pans freely, so the amplitude-
// reduced card finish (CARD_FACE_FINISH) is what actually guarantees
// uniform card reading at any view; the pin just keeps day and night
// geometrically alike.
export const DAY_KEY_LIGHT_POS = { x: 40, y: 70, z: 25 };

// Environment-map response shared by the marble table, the vanilla playmat
// overlay and the card faces. Card/table parity is the point: the first qa#78
// fix left cards at the material default 1.0 - a 2.5x flat env veil the
// table didn't have.
export const SCENE_ENV_MAP_INTENSITY = 0.4;

// Time-of-day lighting keyframes (tableScene lerps between them by wall
// clock). Night = full-moon silvery, still well-lit: the blue palette carries
// the mood, never darkness. Night ambient/key sit slightly above their
// pre-qa#78 values to offset the cards' reduced env veil.
export const TOD_KEYFRAMES = [
  //                    ambient RGB              aInt    directional RGB           dInt    bgDim   moonAngle
  { hour: 0,  ambCol: [0.72, 0.76, 0.92], ambInt: 0.70, dirCol: [0.78, 0.82, 0.95], dirInt: 1.5, bgDim: 0.60, moonAngle: 0.5 },
  { hour: 5,  ambCol: [0.72, 0.76, 0.92], ambInt: 0.70, dirCol: [0.78, 0.82, 0.95], dirInt: 1.5, bgDim: 0.60, moonAngle: 0.9 },
  { hour: 6,  ambCol: [0.95, 0.78, 0.58], ambInt: 0.60, dirCol: [1.00, 0.82, 0.58], dirInt: 1.4, bgDim: 0.70, moonAngle: 0.0 },
  { hour: 8,  ambCol: [1.00, 0.93, 0.84], ambInt: 0.65, dirCol: [1.00, 0.95, 0.87], dirInt: 1.5, bgDim: 0.85, moonAngle: 0.0 },
  { hour: 12, ambCol: [1.00, 0.95, 0.90], ambInt: 0.70, dirCol: [1.00, 0.96, 0.90], dirInt: 1.7, bgDim: 0.90, moonAngle: 0.0 },
  { hour: 17, ambCol: [1.00, 0.90, 0.78], ambInt: 0.65, dirCol: [1.00, 0.85, 0.65], dirInt: 1.5, bgDim: 0.85, moonAngle: 0.0 },
  { hour: 19, ambCol: [0.88, 0.68, 0.52], ambInt: 0.60, dirCol: [0.95, 0.70, 0.50], dirInt: 1.4, bgDim: 0.65, moonAngle: 0.0 },
  { hour: 21, ambCol: [0.75, 0.76, 0.90], ambInt: 0.70, dirCol: [0.80, 0.82, 0.95], dirInt: 1.5, bgDim: 0.60, moonAngle: 0.1 },
  { hour: 24, ambCol: [0.72, 0.76, 0.92], ambInt: 0.70, dirCol: [0.78, 0.82, 0.95], dirInt: 1.5, bgDim: 0.60, moonAngle: 0.5 },
];
